import { QueryClient, QueryKey } from '@tanstack/react-query'

import { IBriefingSession } from '@core/entities/briefing'
import { IPermit } from '@core/entities/permit/Permit'
import { IChecklist } from '@core/entities/checklist/Checklist'

import { permitKeys } from '@core/react-query/features/permits/permit'
import { checklistKeys } from '@core/react-query/features/checklists/checklist'
import { ParticipantEntityType } from '@core/modules/briefings'

const queryKeyGetterByEntityType: Record<
  ParticipantEntityType,
  (id: number) => QueryKey
> = {
  PERMIT: (id) => permitKeys.byId({ permitId: id }).queryKey,
  CHECKLIST: (id) => checklistKeys.byId({ checklistId: id }).queryKey,
}

export const optimisticallyHandleBriefingSession = (
  queryClient: QueryClient,
  briefingSession: IBriefingSession,
) => {
  const queryKey = queryKeyGetterByEntityType[
    briefingSession.referenceObjectType
  ]?.(briefingSession.referenceObjectId)

  // In case BE returns referenceObjectType&referenceObjectId that we don't expect
  if (!queryKey) {
    return
  }

  // Optimistically set briefing session to the entity
  queryClient.setQueryData<IPermit | IChecklist>(queryKey, (queryData) =>
    queryData
      ? { ...queryData, lastBriefingSession: briefingSession }
      : queryData,
  )

  // Invalidate to refetch the entity
  queryClient.invalidateQueries({ queryKey })
}
